const html = document.querySelector("html");
const body = document.querySelector(".body");


//====== Registerd ScrollTrigger Plugin ==========
gsap.registerPlugin(ScrollTrigger);

//========= LENIS START =========
const lenis = new Lenis({
  duration: 1,
  smooth:true,
  infinite: false,
  syncTouch:false, // mimic touch device scroll while allowing scroll sync (can be unstable on iOS<16)
  smoothTouch: false,
  easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
  prevent: (node) => {
    // Prevent Lenis on modal content
    return node.classList.contains('modal-content') || node.closest('.modal-content') || node.closest('.modal-overlay');
  }
});

function raf(time){
  lenis.raf(time);
  ScrollTrigger.update();
  requestAnimationFrame(raf);
}

// requestAnimationFrame(raf);
//========= LENIS END =========

//===== LENIS SCROLL CONTROL START =======
let isOpened = false;
function stopLenisScroll(){
  lenis.stop();
  isOpened = true;
}

function startLenisScroll(){
  lenis.start();
  isOpened = false;
}
//===== LENIS SCROLL CONTROL END =======

//==== LOADER ANIMATION START =====
function hideLoader(){
  tl.to(".loader-upper",{
      y:"-100%",
      duration:0.8,
      ease: "sine.inOut",
  })
  // tl.to(".loader-inner",{
  //     x:"100%",
  //     duration:0.8,
  //     ease: "sine.inOut",
  // }, "-=0.15")
}
//==== LOADER ANIMATION END =====

//====== SCROLL & NAVBAR TOGGLE START =========
const mobileMenu = document.querySelector(".aside-mobile");
const mobileMenuBody = mobileMenu.querySelector(".mobile-menu__body");
const overlay = document.querySelector(".overlay");

//========= SCROLL & NAVBAR TOGGLE START =========
const header = document.querySelector(".header");
const scrollThreshold = 10;  // Prevents accidental small scroll triggers
let lastScroll = 0;
function checkScroll(scrollValue){
  const currentScroll = scrollValue ?? window.scrollY;
  const headerClassList = header.classList;
  
  // Prevent small scroll behaviour
  if(Math.abs(checkScroll - lastScroll) < scrollThreshold) return;
  
  // Hide header on scroll down, show on scroll up
  currentScroll > lastScroll && currentScroll > 100 ? headerClassList.add("hidden") : headerClassList.remove("hidden");

  // Sticky after 100px
  currentScroll > 100 ? headerClassList.add("sticky") : headerClassList.remove("sticky");

  if (currentScroll <= 0) header.classList.remove("hidden");

  // update last scroll
  lastScroll = currentScroll;
}
//====== SCROLL & NAVBAR TOGGLE END =========

//======= ACTIVE NAVIGATION LINK START =========
const windowPathname = window.location.pathname;
const navLinks = document.querySelectorAll(".navbar__link");

navLinks.forEach(link =>{
 const navLinkPathname = new URL(link.href, window.location.origin).pathname;
 const isActiveLink = windowPathname === navLinkPathname || (windowPathname === "/index.html" && navLinkPathname === "/")
  link.classList.toggle("active", isActiveLink);
});
//======= ACTIVE NAVIGATION LINK END =========


//======= BANNER CONTENT ANIMATION START =========
function bannerContentsAnimation(){
  const tl = gsap.timeline();
  // Header Animation Start
  tl.from([".header-top__list li",".header__logo", ".header-btn"], {
    opacity: 0,
    y: 50,
    delay: 0.2,
    duration: 1,
    stagger:0.1,
    ease: Expo.easeInOut,
  });
  tl.from([".navbar__link", "#hamburger-btn"], {
      opacity:0,
      y:40,
      duration:0.8,
      stagger:0.1,
      delay:-1,
      ease:"power4.out",
    }
  );
  // Header Animation End
  tl.from(".hero-title", {
    opacity: 0,
    duration: 1,
    delay: -1.5,
    stagger:0.1,
    ease: "power3.in",
  });
  const heroSubTitle = document.querySelector(".hero-subTitle");
  heroSubTitle && tl.from(heroSubTitle, {
    opacity: 0,
    duration: 1,
    y: 30,
    delay: -1.05,
    stagger:0.1,
    ease: "power4.out",
  });
  
  const heroBtns = document.querySelectorAll(".banner-btn");
  heroBtns && heroBtns.forEach((heroBtn)=>{
    tl.from(heroBtn, {
      opacity: 0,
      duration: 1,
      y: 30,
      delay: -1,
      stagger:0.1,
      ease: "power4.out",
    });
  })

  tl.fromTo(".banner-counter-wrapper",
    {
      opacity:0,
      scale:0,
      transformOrigin:"left",
    },{
      opacity:1,
      scale:1,
      duration:1,
      delay:-1.65,
      stagger:0.15,
      ease:"power4.inOut",
    }
  )

  const bannerImage = document.querySelectorAll(".banner-img");
  bannerImage && tl.from(bannerImage, {
    opacity: 0,
    // y: 30,
    duration: 1,
    delay: -2.10,
    stagger:0.1,
    ease:"power4.in",
  });
  

  tl.from(".form__group",{
    opacity:0,
    y:30,
    duration:0.8,
    delay:-2,
    stagger:0.1,
    ease:"power4.in"
  })

  tl.from(".team-img", {
    opacity:0,
    y:50,
    duration:1,
    stagger:0.1,
    delay:-2,
    ease:"power4.in"
  })

  // tl.from(".connect__title",{
  //   opacity:0,
  //   duration:1,
  //   delay:-1.85,
  //   ease:"power4.in"
  // })

  // tl.from(".connect__link",{
  //   opacity:0,
  //   y:30,
  //   delay:-1.5,
  //   duration:1,
  //   stagger:0.2,
  //   ease:"power4.inOut"
  // })
  tl.from(".socials__list li",{
    opacity:0,
    y:30,
    delay:-1.65,
    duration:1,
    stagger:0.2,
    ease:"power4.inOut"
  });
}
//======= BANNER CONTENT ANIMATION END =========

//====== TOGGLE MOBILE SUBMENU START ==========
const mobileMenuLinks = document.querySelectorAll(".mobile-menu__item");
const mobileMenuLinksArr = Array.from(mobileMenuLinks);
const hamburgerBtn = document.getElementById("menuToggle");

const tl = gsap.timeline();
hamburgerBtn.addEventListener('click', function(){
  this.classList.toggle("active");
  mobileMenu.classList.toggle("show");
  overlay.classList.toggle("show");
  mobileMenuLinksArr.forEach((mobileLink)=>{
    gsap.fromTo(mobileLink,
      {
        opacity:0,
        y:30,
      },{
        opacity:1,
        y:0,
        duration:1,
        stagger:1,
        ease:"power3.out"
      }
    );
  });
  tl.fromTo(".socials__item", 
    {
      opacity:0,
      y:30,
    },{
      opacity:1,
      y:0,
      stagger:0.2,
      delay:-0.1,
      duration:0.85,
      ease:"power3.out",
    }
  )
  !isOpened ? stopLenisScroll() : startLenisScroll();
});

window.onresize = function(){
 	if(this.innerWidth > 1199){
     if(mobileMenu.classList.contains("show")){
      hamburgerBtn.classList.remove("active")
 			mobileMenu.classList.remove("show");
      overlay.classList.remove("show");
      startLenisScroll();
 		}
 	}
 }
//====== TOGGLE MOBILE SUBMENU END ==========


// ===== LAZY LOADING BACKGROUND IMAGES START =====
let lazyBackgrounds = [].slice.call(document.querySelectorAll("[data-bg]"));
if ("IntersectionObserver" in window) {
  const lazyBackgroundObserver = new IntersectionObserver((entries, observer) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        let lazyBackground = entry.target;
        let imgUrl = lazyBackground.getAttribute("data-bg");

        // Preload image first, then set background + fade in
        const img = new Image();
        img.src = imgUrl;

        img.onload = () => {
          if (entry.target.classList.contains("overlay-gradient")) {
            let linearGradient = "linear-gradient(to bottom, rgba(0, 0, 0, 0.65), rgba(0, 0, 0, 0.65))";
            lazyBackground.style.backgroundImage = `${linearGradient}, url("${imgUrl}")`;
          } else {
            lazyBackground.style.backgroundImage = `url("${imgUrl}")`;
          }

          lazyBackground.classList.remove("lazy");
          lazyBackground.classList.add("is-loaded"); // triggers fade in
        };

        img.onerror = () => {
           lazyBackground.style.backgroundColor = '#060606'; // brand dark color
          lazyBackground.classList.add("is-loaded"); // fallback
        };
        lazyBackgroundObserver.unobserve(lazyBackground);
      }
    });
  });

  lazyBackgrounds.forEach((lazyBackground) => {
    lazyBackgroundObserver.observe(lazyBackground);
  });
}
// ===== LAZY LOADING BACKGROUND IMAGES END =====

//===== ACCORDION START ======
let content;
function toggleAccordion(element){ 
  element.classList.toggle("is-open");
  content = element.nextElementSibling;
  if(content){
    const isOpening = content.style.maxHeight;
    content.style.maxHeight = isOpening ? null : `${content.scrollHeight}px`;
    gsap.fromTo(content.children, 
      { opacity: 0, y:50 },
      { opacity: 1, y:0, duration:0.75, stagger:0.2, ease:"power4.out"}
    );
  }
}

const accordionBtns = document.querySelectorAll(".accordion-title");
accordionBtns?.forEach((accordion) => {
  accordion.addEventListener("click",function (e){
    e.stopPropagation();
    toggleAccordion(accordion);
    accordionBtns.forEach(otherAccordion => {
      if(otherAccordion !== accordion) {
        otherAccordion.classList.remove("is-open");
        otherAccordion.nextElementSibling.style.maxHeight = null;
      }
    });
  });
});

const mobileSubmenus= document.querySelectorAll(".mobileSubmenu");
const megaMobileMenu = document.querySelector(".megaMobileSubmenu");
const goBackBtn = document.querySelector(".go-back");

mobileSubmenus.forEach((mobileSubmenu)=>{
  mobileSubmenu.addEventListener("click", function(){
    // toggleAccordion(this)
    megaMobileMenu.classList.add("opened");
  });
  goBackBtn.addEventListener("click",()=>{
    megaMobileMenu.classList.remove("opened");
  });
});

//===== ACCORDION END ======

//===== FLOATING INPUT LABLE START =====
document.querySelectorAll(".form__control").forEach((input) => {
  input.addEventListener("focus", () => input.nextElementSibling.classList.add("focused"))
  input.addEventListener("blur", () => input.nextElementSibling.classList.toggle("focused", input.value !== ""));
}); 
//===== FLOATING INPUT LABLE END ======

const swiperServices = new Swiper(".swiper-services",{
  spaceBetween: 10,
  slidesPerView: 1.15,
  grabCursor: true,
  navigation:{
      nextEl:"#swiper-next-services",
      prevEl:"#swiper-prev-services",
  },
  breakpoints:{
      576:{
          slidesPerView: 2,
          spaceBetween: 16,
      },
      768:{
          slidesPerView:3,
          spaceBetween: 20,         
      },
      // 992:{
      //     slidesPerView:3,
      //     spaceBetween: 24,
      // },
  }
});

gsap.utils.toArray('.timeline-item').forEach(item => {
  gsap.to(item, {
    opacity: 1,
    y: 0,
    duration: 1,
    scrollTrigger: {
      trigger: item,
      start: 'top 80%',
      toggleActions: 'play none none reverse'
    }
  });
});

gsap.utils.toArray('.team-image').forEach(item => {
  gsap.from(item, {
    opacity: 0,
    y: 40,
    duration: 1,
    scrollTrigger: {
      trigger: item,
      start: 'top 80%',
      toggleActions: 'play none none reverse'
    }
  });
});

const fillLine = document.getElementById('fill-line');
const steps = document.querySelectorAll('.process-step__content');

// // Animate steps one by one on scroll
steps.forEach((step, index) => {
  gsap.from(step, {
    opacity: 0,
    y: 30,
    duration: 1,
    scrollTrigger: {
      trigger: "#process",
      start: "top 80%",
      end: "bottom center",
      scrub: true,
      toggleActions: "play none none reverse",
      onEnter: () => updateFillLine(index)
    }
  });
});

// // Function to update the fill line width
function updateFillLine(index) {
  const totalSteps = steps.length;
  const percentage = ((index + 1) / totalSteps) * 100;
  gsap.to(fillLine, {
    width: `${percentage}%`,
    duration: 1,
    ease: "power2.out",
    start: "top 80%",
    end: "bottom center",
    scrub: true
  });
}

//===== MODAL SCRIPT START =======
const modal = document.querySelector(".modal");
const closeModalBtn = document.querySelector("#closeModalBtn");

// Create GSAP Timeline (paused by default)
const modalTl = gsap.timeline({ paused: true });
modalTl.fromTo(modal,
  { y:10, opacity: 0 },
  { y: 0, opacity: 1, duration: 0.5, ease: "power3.out" }
);

// Open Modal
function openModal(mct) {
  modal.classList.add("show");
  document.body.classList.add('modal-open');
  modalTl.play();
  stopLenisScroll();
  ScrollTrigger.update();
}

// Close Modal
function closeModal() {
  modalTl.reverse().then(() => {
    modal.classList.remove("show");
    document.body.classList.remove('modal-open');
    startLenisScroll();
    ScrollTrigger.refresh(); 
  });
}

// Close Button
closeModalBtn?.addEventListener("click", closeModal);

// Close on Overlay Click
modal?.addEventListener("click", (e) => {
  if (e.target === modal) {
    closeModal();
  }
});

// Close on ESC Key
document.addEventListener("keydown", (e) => {
  if (e.key === "Escape" && modal.classList.contains("show")) {
    closeModal();
  }
});

const openModalBtns = document.querySelectorAll(".openModalBtn");
openModalBtns?.forEach((openModalBtn)=>{
  openModalBtn?.addEventListener("click" ,(e) => {
    openModal(e.target);
  });
});


// ======= Modal Script Start =======
const teamMembers = document.querySelectorAll(".readBioBtn");

teamMembers.forEach(member =>{
  member.addEventListener("click", (e)=>{
    const modalImage = modal.querySelector(".modal-img");
    const modalName = modal.querySelector("#modalName");
    const modalTitle = modal.querySelector("#modalTitle");
    const modalDesc = modal.querySelector("#modalDescription");

    const name = member.dataset.name;
    const title = member.dataset.title;
    const desc = member.dataset.description;

    if(modalImage){
      const thumbImageUrl = member.dataset.image;
      modalImage.src = thumbImageUrl;
      modalImage.alt = name;
    }
    modalName.textContent = name;
    modalTitle.textContent = title;

    modalDesc.innerHTML = "";
    desc.split("\n").forEach((paragraph) =>{
      const trimmed = paragraph.trim();
      if(trimmed){
        const p = document.createElement("p");
        p.textContent = trimmed;
        modalDesc.appendChild(p);
      }
    });
    openModal();
  });
});

//===== MODAL SCRIPT END =======

document.querySelectorAll(".description-wrapper").forEach((wrapper)=>{
  const content = wrapper.querySelector(".description");
  const readMoreBtn = wrapper.querySelector(".read-more-btn");
  const btnText = readMoreBtn.querySelector("span");

  if(!content || !readMoreBtn) return;

  // Measure the full Height and Half Height
  const fullHeight = content.scrollHeight;
  const collaspedHeight = content.querySelectorAll("p")[0].offsetHeight + 10;

  console.log(fullHeight, collaspedHeight);

  gsap.set(content, {
    maxHeight: collaspedHeight,
    overflow:"hidden",
  });

  let isExpanded = false;

  readMoreBtn.addEventListener("click", ()=>{
    isExpanded = !isExpanded;
    gsap.to(content, {
      maxHeight:isExpanded ? fullHeight : collaspedHeight,
      duration:0.5, 
      ease:"power4.out"
    });

    btnText.textContent = isExpanded ? "Read Less" : "Read More";
  });
});


//====== SET SECTION WIDTH START =====
const elements = document.querySelectorAll("[data-maxWidth], [data-align]");
elements.forEach((el)=>{
  const {maxwidth, align} = el.dataset;
  const alignValue = align?.trim().toLowerCase();
  if(alignValue === "center"){
    el.style.marginInline = "auto";
    el.style.textAlign = alignValue;
  }
  if(alignValue === "right") el.style.textAlign = alignValue;
  if(maxwidth) el.style.maxWidth = maxwidth;
});
//====== SET SECTION WIDTH END =====


//======== LOTTIE ANIMATION FOR ANIMATED ICONS START ===========
const lottieAnimElements = document.querySelectorAll(".lottie-animation-html");
let lottieAnimElement;
let iconAnimation;
lottieAnimElements.forEach((lottieAnimElem, index) => {
    lottieAnimElement = lottieAnimElem;
    const filePath = lottieAnimElem.dataset.filepath;
    iconAnimation = lottie.loadAnimation({
      container: lottieAnimElem,
      renderer: 'svg',
      loop: true,
      // autoplay: false,
      path:filePath,
    });
});
//======== LOTTIE ANIMATION FOR ANIMATED ICONS END ===========


//====== ANIMATIONS SCRIPT START =========
const textContainers = gsap.utils.toArray(".fade-up");
textContainers.forEach((textContainer, i) => {
  gsap.fromTo(textContainer,
    { opacity: 0, y: 50 },
    { opacity: 1, y: 0, duration: 1, stagger:0.2, ease:"power2.out",
      scrollTrigger:{
        trigger: textContainer,
        // animation: anim,
        // toggleActions: "play",
        // once: true,
        toggleActions: "play none none none",
        once: true
      }
    }
  );
});

const fadeIn = gsap.utils.toArray(".fade-in");
fadeIn.forEach((mainContent, i) => {
  const anim = gsap.fromTo(mainContent,
    { opacity: 0 },
    { opacity: 1, duration: 1, ease: "power2.in",
       scrollTrigger:{
        trigger: mainContent,
        // animation: anim,
        // toggleActions: "play",
        toggleActions: "play none none none",
        once: true
      }
    }
  );
});
//====== ANIMATIONS SCRIPT END =========

const dividers = gsap.utils.toArray(".divider");
dividers.forEach((divider, i)=>{
  const anim = gsap.fromTo(divider,
    { opacity:0, width:"0%", transformOrigin:"left"},
    { opacity:1, width:"100%", duration:1.5, ease:"power4.inOut"}
  )
  ScrollTrigger.create({
    trigger: divider,
    animation: anim,
    toggleActions: "play",
    once: true,
    duration: 1.5,
    // delay:-0.1,
    stagger:0.1,
    ease: "power4.inOut",
  });
})

//====== FILTERS START =======
const tabBtns = document.querySelectorAll(".tab-btn");
tabBtns?.forEach((filterBtn) => {
  filterBtn.addEventListener("click", (e)=> filterCards(e.target.dataset.value));
});
  
//==== FILTER PORTFOLIO START ========
function filterCards(category){
  const cards = document.querySelectorAll('.filter-cards');
  cards.forEach((card) => {
    let cardCategories = card.dataset.category.split(' ');
    const isVisible = category === "all" || cardCategories.includes(category)
    card.classList.toggle("show", isVisible);
    gsap.fromTo(card,
      {
        opacity:0,
        scale:1.0125,
      },
      {
        opacity:1,
        duration:0.5,
        stagger:0.1,
        scale:1,
        ease:"power3.in",
      }
    );
  });
  updateButtonState(category);
}
  
//----- Update Button State -----
function updateButtonState(category){
  tabBtns.forEach((tabBtn) => {
    const isActive = tabBtn.getAttribute("data-value") === category;
    tabBtn.classList.toggle("active", isActive);
  });
}
//====== FILTER PORTFOLIO END =============


//====== SROLL BACK TO TOP START ======
const backToTopBtn = document.getElementById("backToTop");
function toggleBackToTop(scrollY){
  if(backToTopBtn){
    if (scrollY > 1200) {
      backToTopBtn.classList.add("show");
      gsap.to(backToTopBtn, { autoAlpha: 1, duration: 0.5 });
    } else {
      backToTopBtn.classList.remove("show");
      gsap.to(backToTopBtn, { autoAlpha: 0, duration: 0.5 });
    }
  }
}

document.addEventListener("DOMContentLoaded", ()=>{
  // Scroll to top smoothly with lenis
  backToTopBtn?.addEventListener("click", ()=> lenis.scrollTo(0, {duration:1.2}));
  // Run once on load
  toggleBackToTop(lenis.scroll);
});
//====== SROLL BACK TO TOP END ======

// Lenis scroll event
const onLenisScroll =(e)=>{
  const scrollY = e.scroll;
  checkScroll(scrollY);
  toggleBackToTop(scrollY);
  ScrollTrigger.update();
}
lenis.on('scroll', onLenisScroll);

window.addEventListener("load",()=>{
  hideLoader();
  bannerContentsAnimation();
  tabBtns.length && filterCards('all');
});

// Sync Lenis with GSAP
gsap.ticker.add((time)=>{
  lenis.raf(time * 1000);
});

// Disable GSAP lag smoothing for better performance
gsap.ticker.lagSmoothing(0);
